import * as types from "./ac_actionTypes";

const initialState = {
    currentPlan: {},
    creditUsage: {},

    loading: true,
};

const acReducers = (state = initialState, action) => {
    switch (action.type) {

        case types.get_current_plan:
            return {
                ...state,
                currentPlan: action.payload,
                loading: false,
            };
        case types.get_credit_usage:
            return {
                ...state,
                creditUsage: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export default acReducers;